/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Permissions_Roles_Rolepermissions2Inputs */

const en_usermanagement_permissions_roles_rolepermissions2 = /** @type {(inputs: Usermanagement_Permissions_Roles_Rolepermissions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role permissions`)
};

/**
* | output |
* | --- |
* | "Role permissions" |
*
* @param {Usermanagement_Permissions_Roles_Rolepermissions2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_permissions_roles_rolepermissions2 = /** @type {((inputs?: Usermanagement_Permissions_Roles_Rolepermissions2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Permissions_Roles_Rolepermissions2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_permissions_roles_rolepermissions2(inputs)
});
export { usermanagement_permissions_roles_rolepermissions2 as "userManagement_permissions_roles_rolePermissions" }